import { LoginForm } from '@/features/authentication/components/LoginForm';

export function LoginPage() {
  return (
    <div className="flex justify-center items-center min-h-screen p-4">
      <div className="w-full max-w-md">
        <LoginForm />
      </div>
    </div>
  );
}
